import sideBarMenu from './modules/sideBarMenu'

export default {
    sideBarMenu
}
